export default __webpack_public_path__ + "static/qrcode-download-app-1c64f9784b62206b4e1fdf75e63e08eb.jpeg";